export enum UrlsConstant {
  product = '#/module/product/addUpdate',
  moisture = 'module/moisture/addUpdate',
  pH = 'module/ph/addUpdate',
  solubility = 'module/solubility/addUpdate',
  funnelStage = 'module/funnelStage/addUpdate',
  process = 'module/process/addUpdate',
  costHead = 'module/costHead/addUpdate',
  department = '#/module/department/addUpdate',
  crmActivity = 'module/crmActivity/addUpdate',
  party = '#/module/party/addUpdateParty',
  materialType = 'module/productType/addUpdate',
  purity = 'module/purity/addUpdate',
  transport = 'module/transport/addUpdate',
  packing = 'module/packing/addUpdate',
  machine = 'module/machine/addUpdate',
  po = '#/module/purchase-order/addUpdate',
  so = 'module/sales-order/addUpdateSalesOrder',
  location = 'module/location/locationAddUpdate',
  branch = 'module/branch/branchAddUpdate',
}
